import React from "react";
import { Helmet } from "react-helmet";
import RandingStyle1 from "../../randing/RandingStyle1";
import RandingStyle14 from "../../randing/RandingStyle14";

function Randing046({ urlCode, urlCodeSettingId, apiUrl }) {
  return (
    <>
      <Helmet>
        <script>
          {`
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-NMKKSSDC');
          `}
        </script>
      </Helmet>

      <div
        dangerouslySetInnerHTML={{
          __html: `
            <!-- Google Tag Manager (noscript) -->
            <noscript>
              <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NMKKSSDC"
              height="0" width="0" style="display:none;visibility:hidden"></iframe>
            </noscript>
            <!-- End Google Tag Manager (noscript) -->
          `,
        }}
      ></div>

      <RandingStyle14
        urlCode={urlCode}
        urlCodeSettingId={urlCodeSettingId}
        totalStep="2"
        img1Path={`${process.env.REACT_APP_CDN_BASE}/images/046/20241230_01.png`}
        img2Path={`${process.env.REACT_APP_CDN_BASE}/images/046/20241230_02.gif`}
        img3Path={`${process.env.REACT_APP_CDN_BASE}/images/046/20241230_03.png`}
        img4Path={`${process.env.REACT_APP_CDN_BASE}/images/046/q1.png`}
        img5Path={`${process.env.REACT_APP_CDN_BASE}/images/046/q2.png`}
        img6Path={`${process.env.REACT_APP_CDN_BASE}/images/046/q3.png`}
        btnOption1={`${process.env.REACT_APP_CDN_BASE}/images/046/craft_01`}
        btnOption2={`${process.env.REACT_APP_CDN_BASE}/images/046/craft_02`}
        btnOption3={`${process.env.REACT_APP_CDN_BASE}/images/046/craft_03`}
        btnOption4={`${process.env.REACT_APP_CDN_BASE}/images/046/craft_btn_01`}
        btnOption5={`${process.env.REACT_APP_CDN_BASE}/images/046/craft_btn_02`}
        btnOption6={`${process.env.REACT_APP_CDN_BASE}/images/046/craft_btn_03`}
        postBTN={`${process.env.REACT_APP_CDN_BASE}/images/046/postBTN.gif`}
        companyName="본원"
        // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
        apiUrl={apiUrl}
      />
    </>
  );
}

export default Randing046;
